import React from "react";
import { Box, CircularProgress } from "@mui/material";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormProjectSettings from "../../components/project-settings/FormProjectSettings";
import { useGetProjectSettings } from "../../hooks/project-settings/useGetProjectSettings";
import { useUpdateProjectSettings } from "../../hooks/project-settings/useUpdateProjectSettings";

const ProjectSettingsPage = () => {
    const { isLoading, error, settingsData } = useGetProjectSettings();
    const { updateProjectSettingsMutate, isPending } = useUpdateProjectSettings();

    if (isLoading) {
        return (
            <WrapperSection>
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    if (error) return null;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormProjectSettings
                currentData={settingsData}
                onSubmit={updateProjectSettingsMutate}
                isLoading={isPending}
            />
        </WrapperSection>
    );
};

export default ProjectSettingsPage;
